export const GET_GENERAL_PROMOTIONS = 'GET_GENERAL_PROMOTIONS';